import React, { useContext, } from 'react';

import "../../../ui-styles/bottomSlider/BottomSlider.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/prescription/prescriptionAdd.css";
import "../../../ui-styles/conference/confFooter.css";
import { LangCtx, RoleCtx } from "../../../lib/context";
import Button from "../../../lib/ui/buttons/Button";


import "../../../ui-styles/picker/picker.css";

const ConfirmEndCall = (props) => {
    const { l } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);

    
    return (
        <div className={props.openConfirmation ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                {role === 'D' ? 
                    <span className="hdrTxt">{l.exit_or_end}</span>
                    :
                    <span className="hdrTxt">{l.exit_meeting}</span>
                }
                    <div className="hdrClose" onClick={props.handleClose}></div>
                </div>
                <div className="btmSliderBdy">
                <div className="reminderContentBlock">
                    <div className="reminderBlock">
                        {role === 'D' ? 
                        <p className="confirmationTxt">{l.are_sure_exit_meeting_everyone}</p>
                        : <p className="confirmationTxt">{l.are_sure_exit_meeting}</p>}
                    </div>
                    {role === "D" && 
                    <div className="noteBlock">
                        <p className="noteHeading ">
                            <span className="mrgRight8"><img src="/images/icons/note.png" alt="icon" /></span>
                            <span className="noteHeadingTxt redTxt">{l.instavc_note}:</span></p>
                        <p className="notesmallTxt">&bull; <strong>{l.exit_meeting}</strong> {l.will_let_alone_exit}</p>
                        <p className="notesmallTxt">&bull; <strong>{l.end_for_all}</strong> {l.will_end_for_everyone}</p>
                    </div>}
                    <div className="reminderActions justifyCenter">
                    {role === "D" ?
                        <>
                            <Button
                                    label={l.exit_meeting}
                                    size="sm"
                                    type="primary"
                                    onClick={(e) => props.handleEndCall(false)}
                                />
                            <Button
                                    label={l.end_for_all}
                                    size="sm"
                                    type="outLine"
                                    onClick={(e) => {
                                        console.log("Doctor clicked End for All");
                                        props.handleEndCall(true)}}
                            />
                        </>
                    :
                        <Button
                            label={l.exit_meeting}
                            size="sm"
                            type="primary"
                            onClick={(e) => {    
                                props.handleEndCall(false)}}
                        />
                    }
                    </div>
                </div>
                </div>

            </div>
        </div>
    )
}
export default ConfirmEndCall;




// {/* <button className="ivcBtn primary Md mrgRight" onClick={props.handleEndCall}>
//                             <span>{l.exit_meeting}</span>
//                         </button> 
//                         // {/* {role && role === 'D' && */}
                        // <button className="ivcBtnOutline primary Md mrgRight">
                        //     <span>{l.end_for_all}</span>
                        // </button>
                        // <button className="ivcBtnOutline primary Md" onClick={props.handleEndConfirmation}>
                        //     <span>{l.cancel}</span>
                        // </button> */}